import { ExternalLink, Bot } from 'lucide-react'
import styles from './MCPDeploymentPage.module.css'

const MCP_URL = 'https://selfserve.apteancloud.com/mcp'

export function MCPDeploymentPage() {
  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.headerIcon}>
            <Bot size={20} />
          </div>
          <div>
            <h1 className={styles.pageTitle}>MCP Servers</h1>
            <p className={styles.pageSubtitle}>Model Context Protocol server management</p>
          </div>
        </div>
      </div>

      <div className={styles.fallbackCard}>
        <Bot size={48} className={styles.fallbackIcon} />
        <h2 className={styles.fallbackTitle}>MCP Server Management</h2>
        <p className={styles.fallbackDesc}>
          The MCP Servers portal cannot be embedded due to browser security restrictions
          on the external site. Open it in a new window to manage your MCP servers.
        </p>
        <a
          href={MCP_URL}
          target="_blank"
          rel="noreferrer"
          className={styles.openBtn}
        >
          <ExternalLink size={16} />
          Open MCP Servers
        </a>
      </div>
    </div>
  )
}
